import { useQuery } from "@tanstack/react-query"
import { apiTokensQuery } from "../lib/apiTokensQuery"

export function useApiTokensQuery() {
  return useQuery(apiTokensQuery())
}
